import sample_1 from './100_0000.jpg';

export const basicsReflectImpressions = {
    sample_1,
};
